<mat-toolbar color="accent">Update Next Run Date</mat-toolbar>

<form [formGroup]="form">
  <mat-dialog-content>
    <div class="flex flex-col gap-6">
      @if (data.message) {
        <pr-information-box>{{ data.message }}</pr-information-box>
      }

      <div class="flex items-start gap-4">
        <pt-iso-date-selector
          class="flex-1"
          placeholder="Run Date"
          formControlName="recurrenceRunDate"
          subscriptSizing="dynamic"
          startView="month"
          [min]="minDate"
        />

        <div class="mt-1.5 text-xl">&commat;</div>

        <pt-iso-time-selector
          class="min-w-0 flex-1"
          label="Run Time"
          formControlName="recurrenceRunTime"
          floatLabel="always"
          subscriptSizing="dynamic"
        />
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <pt-buttons-container padding="none">
      <button mat-stroked-button mat-dialog-close>Cancel</button>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!form.valid"
        (click)="submit()"
      >
        Save
      </button>
    </pt-buttons-container>
  </mat-dialog-actions>
</form>
